export default __webpack_public_path__ + "static/media/Disclosure-Notice-2025.af768f9b.pdf";